import {useState} from "react";

const useAnychartAnnotations = (ref, chartRef)=>{
    const [drawingAnnotation, setDrawingAnnotation] = useState(false);
    const [selectedAnnotationPoints, setSelectedAnnotationPoints] = useState(null);
    const [selectedAnnotation, setSelectedAnnotation] = useState(null);
    const [annotationsJson, setAnnotationsJson] = useState({});


    const updateAnnotations = () => {
        setAnnotationsJson(ref?.current?.toJson());
    }

    const startAnnotation = (type, props) => {
        if (!ref?.current) {
            console.error("Chart controller is not initialized");
            return;
        }
        ref?.current.startDrawing(type);
        chartRef?.current?.listen("annotationDrawingFinish", function(e){
            setDrawingAnnotation(false);
            updateAnnotations()
        })
    };

    const removeAnnotation = (annotation) => {
        ref?.current.removeAnnotation(annotation);
        updateAnnotations()
    }



    const handleAnnotationChange = ({color, thickness, opacity, xRange, labelText}) => {
        selectedAnnotation.normal().stroke(color, thickness);
        selectedAnnotation.selected()?.fill?.({color, opacity: opacity < 0.9 ? opacity + 0.1 : 1})
        selectedAnnotation.selected().markers({
            enabled: true,
            type: 'circle', // You can change this to 'square', 'diamond', etc.
            size: 8, // Adjust the size as needed
            fill: 'rgba(13, 42, 76, 0.7)', // Change this to your desired color
            stroke: {
                color: '#000000', // Border color
                thickness: 1,
            },
        });
        selectedAnnotation.normal()?.fill?.({
            color,
            opacity
        });
        if (xRange && xRange?.[0] !== null){
            try {
                const start = xRange[0];
                const end = xRange[1] ?? xRange[0];
                selectedAnnotation?.xAnchor?.(start);
                selectedAnnotation?.secondXAnchor?.(end);
                // updateSelectedAnchorsAndPoints(start, end);
            }catch(e){
            }
        }
        if (selectedAnnotation.getType() === 'label'){
            selectedAnnotation.text(labelText);
        }
        updateAnnotations()

    }


    const handleSnapToValue = (seriesName) => {
        if (!selectedAnnotationPoints) return;

        try {
            // Find the x1 and x2 points for the given seriesName
            const x1Data = selectedAnnotationPoints.x1.find(point => point.seriesName === seriesName);
            const x2Data = selectedAnnotationPoints.x2.find(point => point.seriesName === seriesName);

            // Get the valueAnchor from x1
            const valueAnchor = x1Data ? x1Data.pct : null;
            // Get the secondValueAnchor from x2
            const secondValueAnchor = x2Data ? x2Data.pct : null;
            // If selectedAnnotation exists, update its anchors
            selectedAnnotation.valueAnchor(valueAnchor);
            if (secondValueAnchor !== null) {
                selectedAnnotation.secondValueAnchor(secondValueAnchor);
            }
            updateAnnotations()
        }
        catch (error) {
            console.error("Error snapping to value:", error);
        }
    };



    return {
        selectedAnnotationPoints, setSelectedAnnotationPoints,
        selectedAnnotation, setSelectedAnnotation,
        annotationsJson, setAnnotationsJson,
        updateAnnotations, handleAnnotationChange,
        handleSnapToValue,
        startAnnotation, removeAnnotation,
        drawingAnnotation
    }
}


export default useAnychartAnnotations;